import { useEffect, useState } from 'react';
import { getClaims, isAuthenticated, logout as doLogout, type AuthClaims } from './authClient.js';

export function useAuth(): { authed: boolean; claims: AuthClaims | null; logout: () => void } {
  const [state, setState] = useState(() => ({
    authed: isAuthenticated(),
    claims: getClaims(),
  }));

  useEffect(() => {
    const onStorage = (): void => {
      setState({ authed: isAuthenticated(), claims: getClaims() });
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  return { ...state, logout: doLogout };
}
